// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/user/styles/UserProfileHeader.scss
// module id = 1471
// module chunks = 0